import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, Typography, Grid } from "@mui/material";
import { Card, CardContent } from "@mui/material";

function RegenerateBIForm({
  classes: { containerButton, formGroup },
  errors,
  form = {},
  errorMessage = {},
  isFormSubmitted,
  modal,
  retryRegenrationClickHandler,
  terminateMessage,
  terminateClickHandler,
  result = null,
  handleVerifyProceed,
}) {
  return (
    <Box
      p={1}
      sx={{
        maxHeight: 520, // or any height you prefer
        overflowY: "auto",
      }}
    >
      <Box direction="column">
        <>
          {result?.regnenerateBI && (
            <Box className={formGroup} textAlign={"left"}>
              <Typography variant="caption">
                As per your annual income details, we have re-generated the
                benefit illustration for you with revised sum assured. Please
                review the updated details and take the appropriate action.
              </Typography>
            </Box>
          )}

          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Box>
                <Grid container spacing={1}>
                  <Grid item xs={7} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">
                      Existing Sum Assured
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    {result?.sum_assured ? (
                      <Typography variant="caption">
                        &nbsp;&nbsp;
                        {`₹${result?.sum_assured?.toLocaleString("en-IN")}`}
                      </Typography>
                    ) : (
                      <Typography variant="caption">-</Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid container spacing={1} mt={1} textAlign={"left"}>
                  <Grid item xs={8}>
                    <Typography variant="caption">Existing Premium</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    {result?.premium ? (
                      <Typography variant="caption">{`₹${result?.premium?.toLocaleString(
                        "en-IN"
                      )}`}</Typography>
                    ) : (
                      <Typography variant="caption">-</Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid container spacing={1} mt={1} textAlign={"left"}>
                  <Grid item xs={8}>
                    <Typography variant="caption">New Sum Assured</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    {result?.proposed_sa ? (
                      <Typography variant="subtitle1">
                        {`₹${result?.proposed_sa?.toLocaleString("en-IN")}`}
                      </Typography>
                    ) : (
                      <Typography variant="caption">-</Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid container spacing={1} mt={1} textAlign={"left"}>
                  <Grid item xs={8}>
                    <Typography variant="caption">New Premium</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    {result?.proposed_premium ? (
                      <Typography variant="subtitle1">
                        {`₹${result?.proposed_premium?.toLocaleString(
                          "en-IN"
                        )}`}
                      </Typography>
                    ) : (
                      <Typography variant="caption">-</Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </>
      </Box>

      <ErrorMessage errors={errors} modal={modal} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        <>
          {result?.code === 200 && (
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={false}
              isFormSubmitted={isFormSubmitted}
              text={"Verify & Proceed"}
              handleClick={handleVerifyProceed}
            />
          )}

          {result?.code === 400 && (
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={false}
              isFormSubmitted={isFormSubmitted}
              text={"Retry Regeneration"}
              handleClick={() => retryRegenrationClickHandler()}
            />
          )}

          {result?.code === 200 && (
            <Box mt={1}>
              <CallToAction
                buttonType={"click"}
                errorMessage={errorMessage}
                form={form}
                isDisabled={false}
                isFormSubmitted={isFormSubmitted}
                text={"TERMINATE JOURNEY"}
                handleClick={() => terminateClickHandler(terminateMessage)}
                color={"secondary"}
              />
            </Box>
          )}
        </>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(RegenerateBIForm);
